import { useSetRecoilState } from "recoil";

import {
  extractRideAreasSnapshot,
  IRideDto,
  ridePreviousAreasSnapshotAtom,
} from "@ryde/shared";

export const useRideAreasSnapshot = () => {
  const setRidePreviousAreasSnapshot = useSetRecoilState(
    ridePreviousAreasSnapshotAtom,
  );

  const updateRidePreviousAreasSnapshot = (
    rideDto: Partial<IRideDto> | undefined,
  ): void => {
    const areasSnapshot = extractRideAreasSnapshot(rideDto);
    if (areasSnapshot) {
      setRidePreviousAreasSnapshot(areasSnapshot);
    }
  };

  const resetRidePreviousAreasSnapshot = (): void => {
    setRidePreviousAreasSnapshot(null);
  };

  return { updateRidePreviousAreasSnapshot, resetRidePreviousAreasSnapshot };
};
